import FilterBar from "Components/Common/FilterBar/FilterBar";
import AreaFilterCard from "Components/Common/FilterBar/FilterCards/AreaFilterCard/AreaFilterCard";
import RoleFilterCard from "Components/Common/FilterBar/FilterCards/RoleFilterCard/RoleFilterCard";
import YesNoFilterCard from "Components/Common/FilterBar/FilterCards/YesNoFilterCard/YesNoFilterCard";
import i18n from "i18next";
import { Area } from "Models/Areas/Area";
import { TaskRecurrencyType } from "Models/Tasks/TaskRecurrencies/TaskRecurrencyType";
import { RoleType } from "Models/Users/RoleType";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IApplicationState } from "Store/Store";
import { ITaskTemplateAction } from "Store/TaskTemplates/TaskTemplateAction";
import { TaskTemplateFilterState } from "Store/TaskTemplates/TaskTemplateFilterState";
import { ITaskTemplateState } from "Store/TaskTemplates/TaskTemplateState";
import RecurrenceFilterCard from "./CustomFilterCards/RecurrenceFilter/RecurrenceFilterCard";

const taskTemplateAction = ServiceProvider.get<ITaskTemplateAction>(Types.ITaskTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getTaskTemplatesByFilterAsync: (filterState: TaskTemplateFilterState) =>
        dispatch(taskTemplateAction.getTaskTemplatesByFilterAsync(filterState, true)),
});

const mapStateToProps = (state: IApplicationState) => ({
    taskTemplateState: state.taskTemplateState
});

interface IProps {
    taskTemplateState: ITaskTemplateState;
    getTaskTemplatesByFilterAsync: (filterState: TaskTemplateFilterState) => Action;
}

interface IState {
    selectedRecurrenceTypes: TaskRecurrencyType[];
    selectedArea?: Area;
    selectedRoles: RoleType[];
    instructionsAttached?: boolean;
    photoAttached?: boolean;
    videoAttached?: boolean;
}

export class TaskTemplateFilters extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    public static readonly DEBOUNCE_TIMEOUT: number = 500;

    constructor(props: IProps) {
        super(props);

        if (this.props.taskTemplateState.currentFilter) {
            this.state = {
                selectedRecurrenceTypes: this.props.taskTemplateState.currentFilter.recurrenceTypes || [],
                selectedArea: this.props.taskTemplateState.currentFilter.area,
                selectedRoles: this.props.taskTemplateState.currentFilter.roles || [],
                instructionsAttached: this.props.taskTemplateState.currentFilter.instructionsAttached,
                photoAttached: this.props.taskTemplateState.currentFilter.photoAttached,
                videoAttached: this.props.taskTemplateState.currentFilter.videoAttached
            };
        }
        else {
            this.state = {
                selectedRecurrenceTypes: [],
                selectedRoles: []
            };
        }

        this.onChangeRecurrenceTypes = this.onChangeRecurrenceTypes.bind(this);
        this.onChangeRoles = this.onChangeRoles.bind(this);
        this.onChangeInstructionAttached = this.onChangeInstructionAttached.bind(this);
        this.onChangePhotoAttached = this.onChangePhotoAttached.bind(this);
        this.onChangeVideoAttached = this.onChangeVideoAttached.bind(this);
        this.onChangeArea = this.onChangeArea.bind(this);
        this.clear = this.clear.bind(this);
    }

    public onChangeRecurrenceTypes(selectedRecurrenceTypes: TaskRecurrencyType[]) {
        this.setState({
            selectedRecurrenceTypes
        });

        this.filter();
    }

    public onChangeRoles(selectedRoles: RoleType[]) {
        this.setState({
            selectedRoles
        });

        this.filter();
    }

    public onChangeInstructionAttached(value?: boolean) {
        this.setState({
            instructionsAttached: value
        });

        this.filter();
    }

    public onChangePhotoAttached(value?: boolean) {
        this.setState({
            photoAttached: value
        });

        this.filter();
    }

    public onChangeVideoAttached(value?: boolean) {
        this.setState({
            videoAttached: value
        });

        this.filter();
    }

    public onChangeArea(area?: Area) {
        this.setState({
            selectedArea: area
        });

        this.filter();
    }

    public filter() {
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }

        const debounceFunction = () => {
            const filter: TaskTemplateFilterState = {
                ...this.props.taskTemplateState.currentFilter,
                recurrenceTypes: this.state.selectedRecurrenceTypes,
                area: this.state.selectedArea,
                roles: this.state.selectedRoles,
                instructionsAttached: this.state.instructionsAttached,
                photoAttached: this.state.photoAttached,
                videoAttached: this.state.videoAttached,
                skip: 0
            };
            this.props.getTaskTemplatesByFilterAsync(filter);
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), TaskTemplateFilters.DEBOUNCE_TIMEOUT);
    }

    public clear() {
        this.setState({
            selectedRecurrenceTypes: [],
            selectedArea: undefined,
            selectedRoles: [],
            instructionsAttached: undefined,
            photoAttached: undefined,
            videoAttached: undefined
        });
        this.filter();
    }

    public render() {
        return (
            <FilterBar onClear={this.clear}>
                <RecurrenceFilterCard selectedRecurrenceTypes={this.state.selectedRecurrenceTypes} onChange={this.onChangeRecurrenceTypes} />
                <AreaFilterCard onSelectArea={this.onChangeArea} selectedArea={this.state.selectedArea} />
                <RoleFilterCard selectedRoles={this.state.selectedRoles} onChange={this.onChangeRoles} />
                <YesNoFilterCard title={i18n.t("tasks.filters.instructionsAttached")} value={this.state.instructionsAttached} onChange={this.onChangeInstructionAttached} />
                <YesNoFilterCard title={i18n.t("tasks.filters.photoAttached")} value={this.state.photoAttached} onChange={this.onChangePhotoAttached} />
                <YesNoFilterCard title={i18n.t("tasks.filters.videoAttached")} value={this.state.videoAttached} onChange={this.onChangeVideoAttached} />
            </FilterBar>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskTemplateFilters);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateFilters/TaskTemplateFilters.tsx